import React, {useState, useEffect} from 'react';
import ReactApexChart from 'react-apexcharts';
import {Card, CardBody} from "reactstrap";
import pl from "apexcharts/dist/locales/pl.json";
import {connect} from "react-redux";
import {
    clearData,
    clearPrevious,
    deletePreviousFilter,
    getData, getHospital,
    removePlotPoint,
    setActivePlot,
    getYearlyUserData
} from "../../../actions";
import {setOptions} from "leaflet/dist/leaflet-src.esm";

const LineChart = ({PlotData: {yearlyData, active_plot, user_plot_data}, Filters: {previous_filter,start_date, end_date}, Indicators: {available_indicators, active_indicators}, getYearlyUserData, name,value_type,title}) => {
    const [data, SetData] = useState([])
    const dateFormater = (val)=>{

        if(val > 12){
            return val
        }
        if(val==1){
            return "Styczeń";}
        if(val==2){
            return "Luty";}
        if(val==3){
            return "Marzec";}
        if(val==4){
            return "Kwiecień";}
        if(val==5){
            return "Maj";}
        if(val==6){
            return "Czerwiec";}
        if(val==7){
            return "Lipiec";}
        if(val==8){
            return "Sierpień";}
        if(val==9){
            return "Wrzesień"}
        if(val==10){
            return "Październik";}
        if(val==11){
            return "Listopad";}
        if(val==12){
            return "Grudzień";}


        return val
    }
    const valueConvert = (val, prec = 1) => {
        if (typeof val === typeof 1) {

             if(value_type === " dni")
                prec = 0;

            return (Number(val).toFixed(prec)).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".", ",") + value_type

        }

        return val + value_type
    }

    useEffect(() => {
        if (active_plot) {
            if (active_indicators && active_indicators.length > 0) {
                const opk = previous_filter[active_plot] ? Object.values(previous_filter[active_plot])[0] : "none"
                getYearlyUserData(active_plot, opk,start_date,end_date)
            }

        }

    }, [name,user_plot_data])
    useEffect(() => {
        if (yearlyData[active_plot] && yearlyData[active_plot].length > 0) {
            let yourName = undefined;
            if (yearlyData[active_plot].filter(x => x.nazwa_regionu !== "Polska")[0]) {
                yourName = yearlyData[active_plot].filter(x => x.nazwa_regionu !== "Polska")[0].nazwa_regionu
            }

            if (yourName !== undefined) {
                const series = [{
                    name: 'Polska',
                    data: yearlyData[active_plot].filter(x => x.nazwa_regionu === 'Polska').map(x => {
                        try{
                            let splits = x.rok.split('/')
                            let year = new Date(splits[0],splits[1]).getTime()
                            return [Number(splits[1]), x.wartosc_wskaznika,]

                        }catch(e){
                            let year = new Date(x.rok).getTime()
                            return [year, x.wartosc_wskaznika,]
                        }

                    }).sort((a, b) => (a[0] > b[0]) ? 1 : -1)

                }, {
                    name: yourName,
                    data: yearlyData[active_plot].filter(x => x.nazwa_regionu === yourName).map(x => {
                         try{
                            let splits = x.rok.split('/')
                            let year = new Date(splits[0],splits[1]).getTime()
                            return [Number(splits[1]), x.wartosc_wskaznika,]

                        }catch(e){
                            let year = new Date(x.rok).getTime()
                            return [year, x.wartosc_wskaznika,]
                        }

                    }).sort((a, b) => (a[0] > b[0]) ? 1 : -1)
                }]
                SetData(series)
            } else {
                const series = [{
                    name: 'Polska',
                    data: yearlyData[active_plot].filter(x => x.nazwa_regionu === 'Polska').map(x => {
                        try{
                            let splits = x.rok.split('/')
                            let year = new Date(splits[0],splits[1]).getTime()
                            return [Number(splits[1]), x.wartosc_wskaznika,]

                        }catch(e){
                            let year = new Date(x.rok).getTime()
                            return [year, x.wartosc_wskaznika,]
                        }




                    }).sort((a, b) => (a[0] > b[0]) ? 1 : -1)

                }]
                SetData(series)
            }
        }
        else{
            SetData([])
        }


    }, [yearlyData])
    const options={
        chart: {
            height: 350,
            width: 456,
            locales: [pl],
            defaultLocale: "pl",
            type: 'datetime',
            zoom: {
                enabled: false
            }
        },
        dataLabels: {
            enabled: false,
            labels: {
                formatter: function (val) {

                    return valueConvert(val,2)

                }
            }

        },
        stroke: {
            curve: "straight",
        width: 4
        },
        title: {
            text: name,
            align: 'center',
            style: {
                fontSize: '13px',
                fontWeight: 500,
                fontFamily: "Montserrat, Helvetica Neue",
                color: '#263238'
            },
        },
        markers: {
          size:4,
          strokeWidth: 0,
        },
        subtitle: {
            text: title,
            align: 'center',
            margin: 10,
            offsetX: 0,
            offsetY: 25,
            floating: false,
            style: {
                fontSize: '13px',
                fontWeight: 400,
                fontFamily: "Montserrat, Helvetica Neue",
                color: '#263238'
            },
        },
        grid: {
            row: {
                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.5
            },
        },
        xaxis: {
            labels: {
                formatter: function (val) {
                    try {
                        return dateFormater(val,1)
                    } catch (e) {
                        return val


                    }
                }

            },
        },
        yaxis: {
            labels: {
                formatter: function (val) {
                    try {
                        return valueConvert(val,1)
                    } catch (e) {
                        return val

                    }
                }
            }

        },
        colors: ['rgba(107, 188, 212,1)', 'rgb(255,211,35)',],
        noData: {
            text: "Błąd pobierania danych spróbuj ponownie.",
            align: 'center',
            verticalAlign: 'middle',
            offsetX: 0,
            offsetY: 0,
            style: {
                fontSize: '14px',
                fontWeight: 600,
                fontFamily: "Montserrat, Helvetica Neue",
                color: '#263238'
            },
        }
    }

    return (<Card style={{"width": "100%"}}>
            <CardBody style={{"textColor": "white"}}>
                <ReactApexChart options={options} series={data} type="line" height={195} witdh={456}/>
            </CardBody>
        </Card>

    )
};
const mapStateToProps = state => ({
    PlotData: state.PlotData,
    Indicators: state.Indicators,
    Filters: state.Filters,

});


export default connect(mapStateToProps, {
    setActivePlot,
    clearData,
    getData,
    deletePreviousFilter,
    removePlotPoint,
    clearPrevious,
    getYearlyUserData
})(LineChart);
